import { render, staticRenderFns } from "./OptionPropertyAttorneysBackupWorkTogetherOther.vue?vue&type=template&id=bf94c392"
import script from "./OptionPropertyAttorneysBackupWorkTogetherOther.vue?vue&type=script&lang=js"
export * from "./OptionPropertyAttorneysBackupWorkTogetherOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports